(function () {
  "use strict";

  class ConvxMenuSlider extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null;
      this.align = this.dataset.optionPosition;
      this._boundResizeHandler = this.updateFlickity.bind(this);
      this._initPromise = null;
    }

    async initFlickity() {
      if (this.offsetWidth === 0) {
        return;
      }

      if (typeof Flickity === "undefined" && typeof window.loadFlickity === "function") {
        try {
          await window.loadFlickity();
        } catch (error) {
          console.warn("Flickity failed to load for menu slider", error);
          return;
        }
      }

      if (typeof Flickity === "undefined") {
        return;
      }

      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }

      this.flickityInstance = new Flickity(this, this.getFlickityOptions());

      if (typeof imagesLoaded === "function") {
        imagesLoaded(this, () => {
          if (!this.flickityInstance) return;

          void this.offsetHeight;
          this.flickityInstance.reloadCells();
          this.setUniformSlideHeights();
          this.flickityInstance.select(0);
        });
      }
    }

    connectedCallback() {
      window.addEventListener("resize", this._boundResizeHandler);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this._boundResizeHandler);
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }

    getFlickityOptions() {
      return window.innerWidth < 768
        ? {
            cellAlign: "left",
            contain: true,
            draggable: true,
            prevNextButtons: true,
            pageDots: false,
            freeScroll: true,
            percentPosition: true,
            wrapAround: false,
            imagesLoaded: true,
            adaptiveHeight: true,
            lazyLoad: true,
          }
        : {
            cellAlign: "left",
            contain: true,
            draggable: true,
            prevNextButtons: true,
            pageDots: false,
            freeScroll: true,
            percentPosition: true,
            wrapAround: false,
            imagesLoaded: true,
            adaptiveHeight: true,
            lazyLoad: true,
          };
    }

    updateFlickity() {
      if (!this._initPromise) {
        this._initPromise = this.initFlickity().finally(() => {
          this._initPromise = null;
        });
      }

      return this._initPromise;
    }

    setUniformSlideHeights() {
      const slides = this.querySelectorAll(".flickity-slider > *");
      if (!slides.length) return;

      slides.forEach((slide) => {
        slide.style.height = "";
      });

      let maxHeight = 0;
      slides.forEach((slide) => {
        const h = slide.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });

      slides.forEach((slide) => {
        slide.style.height = maxHeight + "px";
      });

      if (this.flickityInstance) {
        this.flickityInstance.resize();
        this.flickityInstance.reloadCells();
      }
    }
  }

  if (!customElements.get("convx-menu-slider")) {
    customElements.define("convx-menu-slider", ConvxMenuSlider);
  }
})();
